import React from 'react'
import styled, { css } from 'styled-components'

const cssReset = css`
  background: transparent;
  border: none;
  padding: 0;
`
const SearchBar = styled.span`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 0 var(--spacing-3);
  width: 100%;
  height: 36px;
`

const SearchInput = styled.input`
  ${cssReset};
  width: 100%;
  outline: none;
  font-size: var(--fontSize-0);
`

const SearchButton = styled.button`
  margin-left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${cssReset};
`

export const SearchIcon = styled.i`
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(var(--ggs, 1));
  width: 16px;
  height: 16px;
  border: 2px solid;
  border-radius: 100%;
  margin-left: -4px;
  margin-top: -4px;
  cursor: pointer;

  &:after {
    content: '';
    display: block;
    box-sizing: border-box;
    position: absolute;
    border-radius: 3px;
    width: 2px;
    height: 8px;
    background: currentColor;
    transform: rotate(-45deg);
    top: 10px;
    left: 12px;
  }
`

const SearchBoxComponent = ({
  noIcon = false,
  className,
  searchTerm,
  onChange,
}) => {
  return (
    <SearchBar className={className}>
      <SearchInput
        type="text"
        placeholder="Search..."
        value={searchTerm}
        onChange={onChange}
      />
      {!noIcon && (
        <SearchButton type="submit">
          <SearchIcon />
        </SearchButton>
      )}
    </SearchBar>
  )
}

export const SearchBox = styled(SearchBoxComponent)``
